import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'
import { Form, Input ,Select, Spin, message } from 'antd';
import {ButtonBase} from '@mui/material';
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
import TextArea from 'antd/es/input/TextArea';

export default function Noti() {

  const [loading,setLoading] = useState(false)
  const [loading2,setLoad2ing] = useState(false)
  const [loading3,setLoad3ing] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const fetchData = async () => {
    setLoad3ing(true);
    let res = await axios.get(`/info/getSystemNotification`)
    setLoad3ing(false);
    if(res.code != 200) return;
    const {
    desc_en,
    desc_zgi,
    desc_uni,
    } = res.data;
    form.setFieldsValue({
        desc_en,
        desc_zgi,
        desc_uni,
    })
  }

  useEffect(()=>{
    fetchData();
  },[])
  
  const onFinish = async (values) => {
    setLoading(true);

    let params = values;
    const data = await axios.put(`/info/updateSystemNotification`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoading(false)
    setOpenAlert(true)
  };

  const onFinish2 = async (values) => {
    setLoad2ing(true)

    let params = values;
    const data = await axios.post(`/info/sendSystemNotification`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoad2ing(false)
    setOpenAlert(true)
  };

  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
 
  return (
    <div
    css={css`
      /* background-color: #ffffff; */
      border-radius: 1rem;
      margin: 0 10rem;
      padding: 1rem;
    `}
  >
      {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
    <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
    <Spin spinning={loading3}>
    <div>
      <Form
        name="basic"
        form={form}
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Upper form={form}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
      <Form
        name="basic"
        form={form2}
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish2}
        autoComplete="off"
      >
        <Lower form={form2}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading2 ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Send</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
    </Spin>
  </div>
  );
}

const Upper = ({form}) =>{

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 100%;
          `}
          label="Marquee Eng"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="desc_en"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <TextArea rows={4} />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 100%;
          `}
          label="Marquee Uni"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="desc_uni"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <TextArea rows={4} />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 100%;
          `}
          label="Marquee Zgi"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="desc_zgi"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <TextArea rows={4} />
        </Form.Item>
      </div>
    
    </div>
  );
}

const Lower = ({form}) =>{

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
          <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Noti Title"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="title"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Noti Description"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="description"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
    
      </div>
    </div>
  );
}